import { el } from '../../core/dom.js';

/** Inline empty copy. The shared empty panel is sized for a whole page. */
export function statusNote(title, body) {
  return el('div', { class: 'kb-status' },
    el('p', { class: 'kb-instr' }, title),
    body ? el('p', { class: 'kb-note' }, body) : null);
}
